'use strict';

var DashboardController = function DashboardController($scope, $q, dataRetrieverService, dataService, dataRetrieverConstantsService, dashboardPanelService, dashboardCommonService, analysisMetricService, configurationService, featureToggleService, userPreferencesService) {
  $scope.brushFilters = {};
  $scope.screen = 'DASHBOARD_SCREEN';
  $scope.isCarouselVisible = false;
  $scope.performanceChartSelectedMonths = [];
  $scope.screenState = {
    aggregationMode: userPreferencesService.getUserSettingComponent('defaultReference') || 'LY',
    dataDimension: 'regular',
    selectedMetric: undefined,
    selectedCabins: undefined,
    dataRepresentation: userPreferencesService.getUserSettingComponent('defaultPerformanceChart') || 'percentage'
  };
  $scope.aggregationModeList = [{
    label: 'Last Year',
    value: 'LY'
  }, {
    label: 'Budget',
    value: 'BUDGET'
  }, {
    label: 'Target',
    value: 'TARGET'
  }];
  if (featureToggleService.isDisabled('POOLED_SEASONALITY')) {
    if (featureToggleService.isEnabled('SEASONAL_AVERAGE_REFERENCE')) {
      $scope.aggregationModeList.push({
        label: 'Season Avg',
        value: 'SEASONAL_AVG'
      });
    } else if ($scope.screenState.aggregationMode === 'SEASONAL_AVERAGE_REFERENCE') {
      $scope.screenState.aggregationMode = 'LY';
    }
  }
  $scope.aggregationModeList[0].active = true;
  var dataRetriever = dataRetrieverService.getDataRetriever($scope.screen, dataRetrieverConstantsService.MARKET_DASHBOARD_MODE);
  var dataFimRetriever = dataRetrieverService.getDataRetriever($scope.screen, dataRetrieverConstantsService.FIM_DASHBOARD_MODE);
  var analysisMetric = analysisMetricService.getAnalysisMetric($scope.screen);
  dataRetriever.setCustomSearchCriteriaRules($q.reject()).selectedDimension($scope.screenState.dataDimension).selectedMetric(analysisMetric.getDefault());
  dataFimRetriever.setCustomSearchCriteriaRules($q.reject());
  $scope.onBrushFilterApplied = function (event, brushFilter) {
    if (event.stopPropagation) {
      event.stopPropagation();
      if (!brushFilter.isEmpty()) {
        $scope.brushFilters[brushFilter.filterType] = brushFilter;
      } else {
        delete $scope.brushFilters[brushFilter.filterType];
      }
      dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
      if (dashboardCommonService.isOneMarketSelected()) {
        dashboardCommonService.dataExistsForSelection().then(function (selectionHasData) {
          $scope.isCarouselVisible = selectionHasData;
          $scope.$broadcast('brush-filter:filterApplied', brushFilter);
        });
      } else {
        $scope.isCarouselVisible = false;
        $scope.$broadcast('brush-filter:filterApplied', brushFilter);
      }
    }
  };
  $scope.onSearchChangeEvent = function () {
    dataService.clearCache();
    $scope.brushFilters = {};
    dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
    $scope.screenState.aggregationMode = userPreferencesService.getUserSettingComponent('defaultReference') || 'LY';
    $scope.aggregationModeList[0].active = true;
    var chartSearchQuery = dashboardPanelService.getDashboardSearchQuery();
    dataRetriever.setCustomSearchCriteriaRules(chartSearchQuery);
    var fimSearchQuery = dashboardPanelService.getFimSearchQuery();
    dataFimRetriever.setCustomSearchCriteriaRules(fimSearchQuery);
  };
  $scope.$on('brush-filter:filterApplied', $scope.onBrushFilterApplied);
  $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChangeEvent);
  $scope.$on('cog:market-performance-chart', function (event, value) {
    if ($scope.screenState.dataRepresentation !== value.val[0]) {
      $scope.screenState.dataRepresentation = value.val[0];
    }
  });
  $scope.$watch('screenState.selectedMetric', function (newValue, oldValue) {
    if (newValue && newValue.id === 'loadFactor') {
      $scope.screenState.selectedCabins = configurationService.getDisplayableCabins();
    } else if (oldValue && oldValue.id === 'loadFactor') {
      $scope.screenState.selectedCabins = undefined;
    }
  });
  $scope.$on('cog:dashboard-toolbar-cog', function (event, value) {
    var dimension = value.val[0];
    if ($scope.screenState.dataDimension !== dimension) {
      $scope.screenState.dataDimension = dimension;
      dataRetriever.updateDimensionValues(dimension);
      if (dimension === 'mapped') {
        if ($scope.screenState.aggregationMode === 'BUDGET' || $scope.screenState.aggregationMode === 'TARGET') {
          $scope.screenState.aggregationMode = 'LY';
          $scope.aggregationModeList[0].active = true;
        }
        $scope.aggregationModeList[1].disabled = true;
        $scope.aggregationModeList[2].disabled = true;
      } else {
        $scope.aggregationModeList[1].disabled = false;
        $scope.aggregationModeList[2].disabled = false;
      }
    }
  });
};
DashboardController.$inject = ['$scope', '$q', 'DataRetrieverService', 'DataService', 'DataRetrieverConstantsService', 'DashboardPanelService', 'DashboardCommonService', 'AnalysisMetricService', 'ConfigurationService', 'FeatureToggleService', 'UserPreferencesService'];
module.exports = DashboardController;